import { render, staticRenderFns } from "./MainCarousel.vue?vue&type=template&id=00fa5c2e&"
import script from "./MainCarousel.vue?vue&type=script&lang=js&"
export * from "./MainCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00fa5c2e')) {
      api.createRecord('00fa5c2e', component.options)
    } else {
      api.reload('00fa5c2e', component.options)
    }
    module.hot.accept("./MainCarousel.vue?vue&type=template&id=00fa5c2e&", function () {
      api.rerender('00fa5c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainCarousel.vue"
export default component.exports